export default {
    finance: {
        loanPrograms: {
            title: "Programu za mkopo",
            create: "Unda programu ya mkopo",
            edit: "Hariri programu ya mkopo",
            details: "Maelezo ya programu",
            programTitle: "Kichwa cha programu",
            programLogo: "Nembo ya programu",
            applicationForm: "Fomu ya maombi",
            viewApplications: "Tazama maombi",
            cooperative: "Ushirika",
            bank: "Benki",
            status: "Hali",
            allStatuses: "Hali zote",
            active: "Inatumika",
            inactive: "Haifanyi kazi",
            approvalFlowSetting: "Mpangilio wa mtiririko wa idhini",
            concludeBeforeBank: "Hitimisha ombi la mkopo kabla ya kulituma benki.",
            allowBankRequestInfo: "Ruhusu benki kuomba taarifa zaidi kutoka kwa mwombaji.",
            currency: "Sarafu",
            loanAmountMin: "Kiasi cha mkopo - Kiwango cha chini",
            loanAmountMax: "Kiasi cha mkopo - Kiwango cha juu",
            term: "Muda",
            yield: "Mapato",
            typeOfFinancing: "Aina ya ufadhili",
            gracePeriod: "Kipindi cha neema",
            country: "Nchi",
            regions: "Mikoa",
            crops: "Mazao",
            dataFields: "Sehemu za data",
            dataFieldsConfigured: "Sehemu za data zilizosanidiwa kwa programu hii ya mkopo",
            signature: "Sahihi",
            viewSignatureFile: "Tazama sahihi / faili",
            description: "Maelezo",
            conditionsRequirements: "Masharti na mahitaji",
            digitalSignature: "Sahihi ya kidijitali",
            fileUpload: "Pakia faili",
            failedLoadLoanProgramDetails: "Imeshindikana kupakia maelezo ya programu ya mkopo",
            failedLoadLoanProgram: "Imeshindikana kupakia programu ya mkopo",
            failedLoadApplicationForm: "Imeshindikana kupakia fomu ya maombi",
            loanProgramUpdatedSuccess: "Programu ya mkopo imesasishwa kwa mafanikio",
            loanProgramCreatedSuccess: "Programu ya mkopo imeundwa kwa mafanikio",
            applicationFormUpdatedSuccess: "Fomu ya maombi imesasishwa kwa mafanikio",
            failedUpdateLoanProgram: "Imeshindikana kusasisha programu ya mkopo",
            failedCreateLoanProgram: "Imeshindikana kuunda programu ya mkopo",
            failedUpdateApplicationForm: "Imeshindikana kusasisha fomu ya maombi",
            fillRequiredFields: "Tafadhali jaza sehemu zote zinazohitajika",
            fileUploadRequiredFor: "Upakiaji wa faili unahitajika kwa",
            selectAtLeastOneOptionFor: "Chagua angalau chaguo moja kwa",
            fieldRequired: "Sehemu hii inahitajika",
            chooseValidOptionFor: "Chagua chaguo halali kwa",
            enterValidAmountFor: "Weka kiasi halali kwa",
            selectValidUnitFor: "Chagua kipimo halali kwa",
            step1ProgramDetails: "Hatua ya 1: Maelezo ya programu",
            step2ApplicationForm: "Hatua ya 2: Fomu ya maombi",
            months: "miezi",
            years: "miaka",
            days: "siku",
            weeks: "wiki",
            previewForm: "HAKIKI FOMU",
            backUpper: "RUDI",
            basicInformation: "Taarifa za msingi",
            basicInformationHint: "Weka taarifa za msingi kwa programu ya mkopo.",
            enterProgramTitle: "Weka kichwa cha programu",
            attachProgramLogo: "Ambatisha nembo ya programu",
            selectProgramLogoImage: "Chagua picha ya nembo ya programu",
            selectFileUploadProgramLogo: "Chagua faili la kupakia nembo ya programu",
            orDragDrop: "au buruta na udondoshe hapa",
            removeFile: "Ondoa faili",
            loanProgramSettings: "Mipangilio ya programu ya mkopo",
            loanProgramSettingsHint: "Weka mipangilio ya programu ya mkopo.",
            selectBank: "Chagua benki",
            applicationApproval: "Uidhinishaji wa maombi",
            applicationProcess: "Mchakato wa maombi",
            loanDetails: "Maelezo ya mkopo",
            loanDetailsHint: "Weka maelezo ya mkopo kwa programu ya mkopo.",
            selectCurrency: "Chagua sarafu",
            enterMinLoanAmount: "Weka kiwango cha chini cha mkopo",
            enterMaxLoanAmount: "Weka kiwango cha juu cha mkopo",
            enterHere: "Ingiza hapa",
            interestRate: "Kiwango cha riba",
            yieldPerYear: "Mapato - kwa mwaka",
            enterYieldPerYear: "Weka mapato kwa mwaka",
            selectTypeOfFinancing: "Chagua aina ya ufadhili",
            gracePeriodMax: "Kipindi cha neema - kiwango cha juu",
            selectCrops: "Chagua mazao",
            selectCountry: "Chagua nchi",
            selectRegions: "Chagua mikoa",
            addNewDataField: "ONGEZA SEHEMU MPYA YA DATA",
            enterProgramDescription: "Ingiza maelezo ya programu",
            programApplicationForm: "Fomu ya maombi ya programu",
            defineAndManageCustomDataFields: "Bainisha na simamia sehemu maalum za data kwa ombi la mkopo.",
            addDataField: "ONGEZA SEHEMU YA DATA",
            dataField: "Sehemu ya data",
            type: "Aina",
            subdata: "Taarifa ndogo",
            mandatory: "Lazima",
            group: "Kundi",
            yes: "Ndiyo",
            no: "Hapana",
            noDataFieldsYet: "Bado hakuna sehemu za data. Bonyeza ONGEZA SEHEMU YA DATA kuunda moja.",
            textField: "Sehemu ya maandishi",
            textArea: "Eneo la maandishi",
            textFieldNumeric: "Sehemu ya nambari",
            radioButton: "Kitufe cha chaguo",
            checkBoxes: "Visanduku vya kuchagua",
            dropdown: "Menyu kunjuzi",
            measurementUnit: "Kipimo",
            attachFile: "Ambatisha faili",
            digitalSignatureLabel: "Sahihi ya kidijitali",
            dataList: "Orodha ya data",
            date: "Tarehe",
            selectDataType: "Chagua aina ya data",
            fieldTitle: "Kichwa cha sehemu",
            groupTitle: "Kichwa cha kundi",
            enterGroupTitle: "Weka kichwa cha kundi",
            allowMultipleInputs: "Ruhusu maingizo mengi",
            allowedFileTypes: "Aina za faili zinazoruhusiwa",
            imageJpegGifPng: "Picha (JPEG, GIF, PNG)",
            videoMp4: "Video (MP4)",
            docx: "DOCX",
            options: "Chaguo",
            typeHere: "Andika hapa",
            unitType: "Aina ya kipimo",
            selectUnitType: "Chagua aina ya kipimo",
            selectType: "Chagua aina",
            allowUserToChangeUnitType: "Ruhusu mtumiaji kubadilisha aina ya kipimo",
            help: "Msaada",
            writeHelpTextUsers: "Andika maandishi ya msaada kwa watumiaji.",
            helpText: "Maandishi ya msaada",
            addHelpTextForThisDataField: "Ongeza maandishi ya msaada kwa sehemu hii ya data",
            addFieldToGroup: "Ongeza sehemu kwenye kundi",
            cancelUpper: "GHAIRI",
            submitUpper: "WASILISHA",
            groupTitleRequired: "Kichwa cha kundi kinahitajika",
            atLeastOneFieldRequiredInGroup: "Angalau sehemu moja inahitajika kwenye kundi",
            fieldTitleRequiredForAllGroupFields: "Kichwa cha sehemu kinahitajika kwa sehemu zote za kundi",
            atLeastOneOptionRequiredFor: "Angalau chaguo moja linahitajika kwa",
            atLeastOneFileTypeMustBeSelected: "Lazima uchague angalau aina moja ya faili",
            fieldTitleRequired: "Kichwa cha sehemu kinahitajika",
            atLeastOneOptionRequired: "Angalau chaguo moja linahitajika",
        },
        loanApplications: {
            activityDescription: "Maelezo ya shughuli",
            activityLog: "Kumbukumbu ya shughuli",
            addAnyInternalNotesOrReviewCommentsAboutThisLoanApplication: "Ongeza maelezo ya ndani au maoni ya mapitio kuhusu maombi haya ya mkopo.",
            additionalInformationRequested: "Taarifa za ziada zimeombwa",
            additionalLoanRelatedQuestionsAndSupportingDocuments: "Maswali ya ziada yanayohusiana na mkopo na nyaraka za uthibitisho.",
            additionalQuestions: "Maswali ya ziada",
            address: "Anwani",
            amount: "Kiasi",
            applicantDetails: "Maelezo ya mwombaji",
            applicationHasBeenSentToTheBankForApproval: "Ombo limetumwa benki kwa uidhinishaji.",
            applicationId: "Kitambulisho cha ombo",
            applicationIdAndSubmissionDate: "Kitambulisho cha ombo na tarehe ya uwasilishaji",
            apply: "Tumia",
            approvalProcess: "Mchakato wa uidhinishaji",
            approvalProcessHasBeenStartedYouCanNowFillFinalizeContractAndLoanDetails: "Mchakato wa uidhinishaji umeanza. Sasa unaweza kujaza Maliza mkataba na Maelezo ya mkopo.",
            approve: "Idhinisha",
            approved: "Imeidhinishwa",
            areYouSureYouWantToApproveTheLoanApplication: "Una uhakika unataka kuidhinisha ombo la mkopo?",
            areYouSureYouWantToRejectTheLoanApplication: "Una uhakika unataka kukataa ombo la mkopo?",
            areYouSureYouWantToSendTheApplicationToTheBankForApprovalProcess: "Una uhakika unataka kutuma ombo benki kwa mchakato wa uidhinishaji?",
            areYouSureYouWantToStartTheApprovalProcess: "Una uhakika unataka kuanzisha mchakato wa uidhinishaji?",
            area: "Eneo",
            areaHa: "Eneo (ha)",
            attachContractOptional: "Ambatisha mkataba (si lazima)",
            attachment: "Kiambatisho",
            back: "Rudi",
            cancel: "Ghairi",
            circular: "Mzunguko",
            close: "Funga",
            closeUpper: "FUNGA",
            confirm: "Thibitisha",
            confirmation: "Uthibitisho",
            contract: "Mkataba",
            couldNotLoadLoanApplication: "Haikuwezekana kupakia ombo la mkopo.",
            couldNotSendRequest: "Haikuwezekana kutuma ombi.",
            couldNotUpdateApplication: "Haikuwezekana kusasisha ombo.",
            country: "Nchi",
            customization: "Kubinafsisha",
            date: "Tarehe",
            dateAndTime: "Tarehe na saa",
            describeHere: "Eleza hapa",
            description: "Maelezo",
            digitallySigned: "Imetiwa saini kidijitali",
            disclaimerTitle: "Kanusho",
            disbursedAmount: "Kiasi kilichotolewa",
            disbursementScheduleFromBankToFarmer: "Ratiba ya malipo kutoka benki hadi mkulima.",
            doYouWantUsToCollectTheContractSignature: "Unataka tusanye saini ya mkataba?",
            doYouWantUsToCollectTheContractSignatureIfYesAttachTheContractOptionalAndWeWillSendItToTheFarmerToSignInTheAppIfNoTheContractIsAlreadySignedOrWillBeSignedOfflineAfterYouAttachAndSaveTheContractWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Unataka tusanye saini ya mkataba? Ikiwa ndiyo, ambatisha mkataba (si lazima) na tutamtumia mkulima aisaini kwenye programu. Ikiwa hapana, mkataba tayari umetiwa saini au utatiwa nje ya mtandao. Baada ya kuambatisha na kuhifadhi, mkataba utatumwa kwa mkulima; utapata arifa inapotiwa saini.",
            download: "Pakua",
            dueDate: "Tarehe ya mwisho",
            email: "Barua pepe",
            enterHere: "Ingiza hapa",
            error: "Hitilafu",
            farm: "Shamba",
            farmDetails: "Maelezo ya shamba",
            farmReports: "Ripoti za shamba",
            farmer: "Mkulima",
            farmerResponse: "Jibu la mkulima",
            farmerUpdates: "Masasisho ya mkulima",
            farmReportsSoilDisclaimer: "Taarifa katika sehemu hii ni kwa marejeleo ya jumla tu. Hazipaswi kuchukua nafasi ya uchambuzi wa udongo wa kitaalamu kwenye maabara. Tumia tu ikiwa chaguo zingine hazipo. Daima shauriana na wataalamu wa kilimo kabla ya maamuzi.",
            farmReportsYieldBullet1: "Haiwezekani kutabiri hali ya hewa kwa msimu mzima kwa usahihi; wakati mwingine wakulima wanapoteza mavuno yote kwa mvua ya mawe au mafuriko (hasa na ongezeko la joto duniani).",
            farmReportsYieldBullet2: "Mavuno yanategemea sana mazoea ya usimamizi. Kwa mfano, dawa za wadudu zisipotumwa kwa wakati au umwagiliaji usipotoshe, mavuno yanaweza kutofautiana sana na utabiri; hili pia liko nje ya udhibiti wetu.",
            farmReportsYieldBullet3: "Kuna mambo mengine mengi yanayoweza kusababisha makosa makubwa katika utabiri wa mavuno wa AI.",
            farmReportsYieldBullet4: "Ikiwa mkulima anatoa mavuno ya kihistoria (hali YA JUU), utabiri huwa sahihi kuliko hali chaguo-msingi (isiyo YA JUU).",
            farmReportsYieldUncertaintyIntro: "Katika utabiri wetu wa mavuno, kutokuwa na uhakika kunaweza kuwa hadi 100% kwa sababu mambo mengi yako nje ya udhibiti wetu, ikiwa ni pamoja na:",
            forecastedYields: "Mavuno yaliyotabiriwa",
            graph: "Grafu",
            yieldsKgAxis: "Mavuno (kg)",
            yieldForecasts: "Utabiri wa mavuno",
            farmerUploadedAttachmentS: "Mkulima amepakia viambatisho.",
            finalizeContract: "Maliza mkataba",
            financeManagement: "Usimamizi wa fedha",
            firstName: "Jina la kwanza",
            generatePaymentSchedule: "TENGENEZA RATIBA YA MALIPO",
            geolocation: "Mahali pa kijiografia",
            gracePeriod: "Kipindi cha neema",
            gracePeriodType: "Aina ya kipindi cha neema",
            historyOfActionsTakenOnThisLoanApplication: "Historia ya vitendo kwenye ombo hili la mkopo.",
            ifYouWantUsToCollectTheApplicantSSignatureChooseYesAndAttachTheContractAfterYouSaveItWillBeSentToTheFarmerToSignInTheAppYouLlReceiveANotificationOnceSignedContractUploadIsOptionalEGIfTheContractIsAlreadySignedOrWillBeSignedOffline: "Ikiwa unataka tusanye saini ya mwombaji, chagua Ndiyo na ambatisha mkataba. Baada ya kuhifadhi, utatumwa kwa mkulima aisaini kwenye programu; utapata arifa inapotiwa saini. Kupakia mkataba si lazima — kwa mfano ikiwa tayari umetiwa saini au utatiwa nje ya mtandao.",
            information: "Taarifa",
            informationRequestedFromBank: "Taarifa zilizoombwa kutoka benki",
            installment: "Malipo ya awamu",
            installmentDetails: "Maelezo ya malipo ya awamu",
            interestRate: "Kiwango cha riba",
            ipAddress: "Anwani ya IP",
            keySoilNutrientLevelsForTheFarm: "Viwango muhimu vya virutubishi vya udongo kwa shamba.",
            landSuitabilityReport: "Ripoti ya kufaa kwa ardhi",
            lastName: "Jina la ukoo",
            loadingData: "Inapakia data...",
            loanAmount: "Kiasi cha mkopo",
            loanApplicationDetails: "Maelezo ya ombo la mkopo",
            loanApplicationHasBeenApproved: "Ombo la mkopo limeidhinishwa.",
            loanApplicationHasBeenRejected: "Ombo la mkopo limekataliwa.",
            loanApplications: "Maombi ya mikopo",
            loanDetails: "Maelezo ya mkopo",
            loanDetailsSummary: "Muhtasari wa maelezo ya mkopo.",
            loanDisbursementBankFarmer: "Utolaji wa mkopo (Benki -> Mkulima)",
            loanDisbursementPlan: "Mpango wa utolaji wa mkopo",
            loanProgram: "Mpango wa mikopo",
            loanPrograms: "Mipango ya mikopo",
            loanRepaymentFarmerBank: "Malipo ya mkopo (Mkulima -> Benki)",
            loanRepaymentPlan: "Mpango wa malipo ya mkopo",
            missingApplicationId: "Kitambulisho cha ombo kinakosekana.",
            moderate: "Wastani",
            notApplicable: "H/A",
            nitrogenContent: "Kiasi cha nitrogeni",
            noAdditionalQuestions: "Hakuna maswali ya ziada.",
            noContractIsAlreadySignedOrWillBeSignedOffline: "Hapana — mkataba tayari umetiwa saini au utatiwa nje ya mtandao",
            noMapCoordinatesForThisFarm: "Hakuna viwianishi vya ramani kwa shamba hili.",
            notes: "Maelezo",
            numberOfDisbursements: "Idadi ya malipo",
            numberOfInstallments: "Idadi ya awamu za malipo",
            of: "ya",
            openFile: "Fungua faili",
            orDragAndDropHere: "au buruta na uache hapa",
            overallLandSuitabilityScoreAndCategory: "Alama na jamii ya ufaaji wa jumla wa ardhi.",
            overallScoreForLandSuitability: "Alama ya jumla ya ufaaji wa ardhi",
            paid: "Imelipwa",
            paymentDetails: "Maelezo ya malipo",
            payments: "Malipo",
            pending: "Inasubiri",
            phoneNumber: "Nambari ya simu",
            phosphorusContent: "Kiasi cha fosforasi",
            pleaseEnterAValidInterestRateToGenerateRepaymentPlan: "Tafadhali ingiza kiwango halali cha riba ili kutengeneza mpango wa malipo.",
            pleaseEnterAValidLoanAmountToGenerateDisbursementPlan: "Tafadhali ingiza kiasi halali cha mkopo ili kutengeneza mpango wa utolaji.",
            pleaseEnterAValidLoanAmountToGenerateRepaymentPlan: "Tafadhali ingiza kiasi halali cha mkopo ili kutengeneza mpango wa malipo.",
            pleaseEnterNumberOfInstallmentsToGenerateRepaymentPlan: "Tafadhali ingiza idadi ya awamu za malipo ili kutengeneza mpango wa malipo.",
            pleaseEnterYourCommentsOrInstructions: "Tafadhali ingiza maoni au maelekezo yako.",
            pleaseProvideSpecificCommentsOrInstructionsInTheTextBoxBelowOnceSubmittedTheFarmerWillBeNotifiedYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Toa maoni au maelekezo mahususi kwenye kisanduku cha maandishi. Baada ya kuwasilisha, mkulima ataarifiwa. Utaarifiwa mkulima akisasisha ombo.",
            polygon: "Poligoni",
            potassiumContent: "Kiasi cha potasi",
            principalAndInterest: "Asili na riba",
            print: "Chapisha",
            projectedYieldComparisonByYear: "Ulinganisho wa mavuno yaliyotabiriwa kwa mwaka.",
            provinceState: "Mkoa / Jimbo",
            question: "Swali",
            recordsPerPage: "Rekodi kwa kila ukurasa",
            regionDistrict: "Mkoa / Wilaya",
            reject: "Kataa",
            rejected: "Imekataliwa",
            repaymentScheduleFromFarmerToBank: "Ratiba ya malipo kutoka mkulima hadi benki.",
            requestAdditionalInformation: "Omba taarifa za ziada",
            restoreDefault: "Rejesha chaguo-msingi",
            search: "Tafuta",
            select: "Chagua",
            selectFileToUploadTheContract: "Chagua faili ili kupakia mkataba",
            selectNoIfYouHaveAlreadySignedTheContractWithTheApplicantFarmerSelectYesIfYouWantTheApplicantFarmerToSignTheLoanContractOnHisDimitraMobileApp: "Chagua Hapana ikiwa tayari umetia saini mkataba na mwombaji (mkulima). Chagua NDIO ikiwa unataka mwombaji (mkulima) atie saini mkataba wa mkopo kwenye programu ya simu ya Dimitra.",
            send: "Tuma",
            sendToBank: "Tuma benki",
            sentToBank: "Imetumwa benki",
            signedOffline: "Imetiwa saini nje ya mtandao",
            soilAnalysisReport: "Ripoti ya uchambuzi wa udongo",
            someDisclaimerOrShortExplainerAboutFollowingReports: "Kanusho au maelezo mafupi kuhusu ripoti zifuatazo.",
            srd: "SRD",
            startDate: "Tarehe ya kuanza",
            status: "Hali",
            statusLegend: "Funguo ya hali",
            submissionDate: "Tarehe ya uwasilishaji",
            success: "Mafanikio",
            tapTheMapToExpandIt: "Gusa ramani ili kuipanua.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponses: "Sehemu hii inaonyesha maombi ya taarifa za ziada yaliyotumwa kwa mkulima na majibu yake.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponsesYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Sehemu hii inaonyesha maombi ya taarifa za ziada yaliyotumwa kwa mkulima na majibu yake. Utaarifiwa mkulima akisasisha ombo.",
            totalInstallments: "Jumla ya awamu za malipo",
            totalInterestApprox: "Jumla ya riba (takriban)",
            totalLoanAmount: "Jumla ya kiasi cha mkopo",
            totalPayment: "Jumla ya malipo",
            totalRepayment: "Jumla ya malipo ya mkopo",
            transactionIdAndDate: "Kitambulisho cha muamala na tarehe",
            typeYourLocationNameAddress: "Andika jina au anwani ya eneo lako",
            upcoming: "Inayokuja",
            uploadTheUnsignedContractAfterYouAttachAndSaveItWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Pakia mkataba usiotiwa saini. Baada ya kuambatisha na kuhifadhi, utatumwa kwa mkulima aisaini. Utapata arifa inapotiwa saini.",
            user: "Mtumiaji",
            userDetails: "Maelezo ya mtumiaji",
            userRole: "Jukumu la mtumiaji",
            validation: "Uthibitishaji",
            viewFullReport: "Tazama ripoti kamili",
            viewGeolocation: "Tazama mahali pa kijiografia",
            villageTownCity: "Kijiji / Mji",
            waitingSignatures: "Inasubiri saini",
            warning: "Onyo",
            year2025: "2025",
            year2026: "2026",
            yesAttachTheContractAndWeLlSendItToTheFarmerToSignInTheApp: "Ndiyo — ambatisha mkataba na tutamtumia mkulima aisaini kwenye programu",
            yieldPredictionReport: "Ripoti ya utabiri wa mavuno",
            youMayUploadTheSignedContractForYourRecordsOrLeaveEmptyIfTheContractIsPrivateOrSignedOffline: "Unaweza kupakia mkataba uliotiwa saini kwa rekodi zako, au uache tupu ikiwa ni siri au umetiwa saini nje ya mtandao.",
            yourRequestHasBeenSentTheFarmerWillBeNotified: "Ombi lako limetumwa. Mkulima ataarifiwa.",
            yieldForecastChartAria: "Grafu ya utabiri wa mavuno",
            yearsAxisLabel: "Miaka",
            soilAnalysisSectionTitle: "Uchambuzi wa udongo",
            soilMetricNitrogenN: "Nitrogeni (N)",
            soilMetricPhosphorusP: "Fosforasi (P2O5)",
            soilMetricPotassiumK: "Potasi (K2O)",
            soilAnalysisPlaceholderTitle: "Maana yake (nafasi ya maandishi)",
            soilAnalysisPlaceholderBody: "Ukurasa huu unaonyesha muhtasari rahisi wa virutubishi vya udongo. Chanzo cha data kikiunganishwa, sehemu hii inaweza panuliwa na grafu kamili za wasifu wa udongo na mapendekezo.",
            landSuitabilitySectionTitle: "Ufaaji wa ardhi",
            overallSuitabilityScoreLabel: "Alama ya jumla ya ufaaji",
            suitabilityFactorsPlaceholder: "Vigezo vya ufaaji (nafasi ya maandishi)",
            factorSoilQuality: "Ubora wa udongo",
            factorClimateFit: "Ulinganifu wa hali ya hewa",
            factorWaterAvailability: "Upatikanaji wa maji",
            factorRiskFactors: "Vigezo vya hatari",
            landSuitabilityExpertFooter: "AI inaweza kukosea; thibitisha na wataalamu wa kilimo wa eneo kabla ya maamuzi.",
        },
        banks: {
            title: 'Benki',
            addNewBank: 'Ongeza benki mpya',
            bankDetails: 'Maelezo ya benki',
            bank: 'Benki',
            bankTitle: 'Jina la benki',
            attachBankLogo: 'Ambatisha nembo ya benki',
            addImage: 'Ongeza picha',
            contactDetails: 'Maelezo ya mawasiliano',
            firstName: 'Jina la kwanza',
            lastName: 'Jina la mwisho',
            email: 'Barua pepe',
            phone: 'Nambari ya simu',
            enterHere: 'Ingiza hapa',
            apiIntegrationInfo: 'Maelezo ya ujumuishaji wa API',
            apiBaseUrl: 'URL msingi ya API',
            clientId: 'Kitambulisho cha mteja / Ufunguo wa umma',
            clientSecret: 'Siri ya mteja / Ufunguo binafsi',
            accountAdminCredentials: 'Taarifa za kuingia akaunti/msimamizi',
            adminUsername: 'Jina la mtumiaji la msimamizi',
            password: 'Nenosiri',
            require2FA: 'Hitaji 2FA',
            enable: 'Washa',
            copy: 'Nakili',
            regenerate: 'Tengeneza upya',
            edit: 'Hariri',
            back: 'Rudi',
            cancel: 'Ghairi',
            save: 'Hifadhi',
            firstNameInfo: 'Maelezo ya jina la kwanza',
            lastNameInfo: 'Maelezo ya jina la mwisho',
            emailInfo: 'Maelezo ya barua pepe',
            phoneInfo: 'Maelezo ya nambari ya simu',
            apiBaseUrlInfo: 'Maelezo ya URL msingi ya API',
            clientIdInfo: 'Maelezo ya kitambulisho cha mteja',
            clientSecretInfo: 'Maelezo ya siri ya mteja',
            adminUsernameInfo: 'Maelezo ya jina la mtumiaji la msimamizi',
            passwordInfo: 'Maelezo ya nenosiri',
            contactPerson: 'Mtu wa mawasiliano',
            management: 'Usimamizi wa fedha',
            editBank: 'Hariri benki',
            changeImage: 'Badilisha picha',
            failedToLoadBankDetails: 'Imeshindikana kupakia maelezo ya benki',
            bankUpdatedSuccessfully: 'Benki imesasishwa kwa mafanikio',
            bankCreatedSuccessfully: 'Benki imeundwa kwa mafanikio',
            errorUpdatingBank: 'Hitilafu wakati wa kusasisha benki',
            errorCreatingBank: 'Hitilafu wakati wa kuunda benki',
            bankLogo: 'Nembo ya Benki',
            bankLogoPreview: 'Hakikisho la nembo ya benki',
            notAvailable: 'Haipatikani',
        },
        dashboard: {
            title: "Dashibodi ya fedha",
            avgLoanAmount: "Kiasi cha wastani cha mkopo",
            vsLastMonth: "dhidi ya mwezi uliopita",
            totalApplications: "Jumla ya maombi",
            approvalRate: "Kiwango cha idhini",
            loanApplicationsChart: "Maombi ya mkopo",
            applicationsByStatus: "Maombi kulingana na hali",
            applicationsByRegion: "Maombi kulingana na eneo",
            regionBreakdown: "Mgawanyo kwa eneo",
            averageLoanAmountTrend: "Mwelekeo wa kiasi cha wastani cha mkopo",
            loanAmountOverTime: "Kiasi cha mkopo kwa muda",
            avgAmount: "Kiasi cha wastani"
        },
        status: {
            approved: "Imeidhinishwa",
            pending: "Inasubiri",
            waiting: "Inangojea",
            rejected: "Imekataliwa"
        },
        reports: {
            today: "Leo",
            week: "Wiki",
            month: "Mwezi",
            year: "Mwaka"
        },
    },
}
